import {
  UPLOAD_RAG_DOCUMENT,
  APPROVE_DOCUMENT_TAGS,
  DELETE_RAG_DOCUMENT,
} from "./Mutations";
import {
  GET_RAG_DOCUMENT_UPLOADS,
  GET_RAG_SOURCE_TYPES,
  GET_ELIGIBLE_PARENT_DOCUMENTS,
} from "./Queries";

export class RagClient {
  constructor(client) {
    this.client = client;
  }

  async uploadDocument({
    file,
    sourceType,
    subject,
    yearGroup,
    educationLevel,
    school,
    parent,
    containsMultipleInstances,
  }) {
    const res = await this.client.mutate({
      mutation: UPLOAD_RAG_DOCUMENT,
      variables: {
        file,
        sourceType,
        subject,
        yearGroup,
        educationLevel,
        school,
        parent,
        containsMultipleInstances,
      },
    });
    return res.data.uploadRagDocument;
  }

  async approveDocumentTags({ ragUpload, tags }) {
    const res = await this.client.mutate({
      mutation: APPROVE_DOCUMENT_TAGS,
      variables: { ragUpload: ragUpload, tags },
    });
    return res.data.approveDocumentTags;
  }

  async deleteDocument({ ragUpload }) {
    const res = await this.client.mutate({
      mutation: DELETE_RAG_DOCUMENT,
      variables: { ragUpload: ragUpload },
    });
    return res.data.deleteRagDocument;
  }

  async getDocumentUploads({ first = 20, after = null, school = null } = {}) {
    const res = await this.client.query({
      query: GET_RAG_DOCUMENT_UPLOADS,
      variables: { first, after, school },
      fetchPolicy: "network-only",
    });
    return res.data.ragDocumentUploads;
  }

  async getSourceTypes() {
    const res = await this.client.query({
      query: GET_RAG_SOURCE_TYPES,
      fetchPolicy: "cache-first",
    });
    return res.data.ragSourceTypes;
  }

  async getEligibleParentDocuments(sourceType) {
    const res = await this.client.query({
      query: GET_ELIGIBLE_PARENT_DOCUMENTS,
      variables: { sourceType },
      fetchPolicy: "network-only",
    });
    return res.data.eligibleParentDocuments;
  }
}
